export const theme = {
  grad1: '#111517',
  grad2: '#1A1F23',
  grad3: '#20262B',
  grad4: '#2B343B',
  grad5: '#343E46',
  grad6: '#5D656B',
  grad7: '#7D8489',
  grad8: '#F1F5F8',
  blue: '#A6CCF0',
  red: '#FF7C7C',
  background: '#212121',
  font: 'monospace'
};

// needed for styled components theme
export const getTheme = () => {
  return theme;
};
